export const GLOBAL_LINK_NO_TX_CLASS = "GlobalLinkNoTx";

export const globalLinkNoTxClass = (...classes: Array<string | false | undefined | null>) =>
  [GLOBAL_LINK_NO_TX_CLASS, ...classes].filter(Boolean).join(" ");
